import {
  Button,
  Field,
  Input,
  InputGroup,
  Stack,
} from '@chakra-ui/react';
import { LuMail } from 'react-icons/lu';
import { BsArrowLeft } from 'react-icons/bs';
import { useNavigate } from 'react-router';
import AuthContainer from '@/components/AuthContainer';
import ConfirmActionDialog from '@/components/ConfirmActionDialog';
import useForm from './useForm';

const ForgotPassword = () => {
  const navigate = useNavigate();

  const { onSubmit, isPending, showConfirmation, validationErrors } = useForm();

  return (
    <AuthContainer
      title="Esqueceu sua senha?"
      subtitle="Insira seu e-mail abaixo para receber instruções de recuperação."
    >
      <form onSubmit={onSubmit}>
        <Stack gap={5}>
          <Field.Root invalid={!!validationErrors?.email}>
            <InputGroup startElement={<LuMail />} width="full" gap={0}>
              <Input name="email" type="email" placeholder="exemplo@email.com" variant="subtle" bg="gray.200" required />
            </InputGroup>
            {validationErrors?.email?.map((error, index) => (
              <Field.ErrorText key={index}>{error}</Field.ErrorText>
            ))}
          </Field.Root>
          <Button size="lg" type="submit" loading={isPending} disabled={isPending}>
            Continuar
          </Button>
        </Stack>
      </form>

      <Button variant="ghost" textDecoration="underline" onClick={() => navigate(-1)}>
        <BsArrowLeft /> Voltar
      </Button>

      {showConfirmation && (
        <ConfirmActionDialog
          open
          onOpenChange={() => navigate(-1)}
          title="Tudo certo!"
          body="Uma mensagem foi enviada para o seu e-mail com as instruções para redefinir sua senha."
          onConfirm={() => navigate(-1)}
          confirmLabel="Ok"
          hideCancelButton
          size="md"
        />
      )}
    </AuthContainer>
  );
};

export default ForgotPassword;
